import { Templator } from "../../../utils";
import axios from "axios";
class Templates extends Templator {
    constructor() {
        super(...arguments);
        this.fetchBulkPublisherAllowListTemplate = async () => {
            const { data } = await axios.get(`${this.sdk.urls.baseAPIUrl}/pub_groups_csv`, {
                responseType: "blob"
            });
            return data;
        };
        this.fetchSinglePublisherAllowListTemplate = async (id) => {
            const { data } = await axios.get(`${this.sdk.urls.baseAPIUrl}/pub_group/${id}/csv`, {
                responseType: "blob"
            });
            return data;
        };
    }
    createTemplate() {
        return this.fetchBulkPublisherAllowListTemplate();
    }
}
export default Templates;
//# sourceMappingURL=templates.js.map